/* eslint-disable max-len */
import React from 'react'

export default function FailedPopup({handleSidePopupClick, setFailureData, failureData, getPayrollUsers}) {
    const failedRecords = failureData?.failed_records || [];
    const failedCount = failureData?.failed_count ?? failedRecords.length;
    const uploadedCount = failureData?.uploaded_count ?? 0;

    return (
        <div className='p-6'>
            <div className='flex'>
                <p className='font-normal text-g3'>
                    <span className='text-[#031624]'># Success:</span>
                    <span className='text-[#00CF3A]'> {`${uploadedCount} Students`}</span>   
                    <span className='text-[#031624]'> # Failed:</span>
                    <span className='text-[#F04438]'> {`${failedCount} Students`}</span>
                </p>
            </div>
            <div className='mt-6'>
                <h1 className='text-[#031624] font-semibold text-g3'>Failed Students</h1>
                <div class=" border border-[#D0D5DD] rounded p-1.5">
                    <div className='max-h-[398px] overflow-auto overflow-x-hidden'>
                        <div className='flex flex-wrap -mx-[5px]'>  
                            {failedRecords.map((item) => (
                                <div className='w-[33%] px-[5px] mb-2.5' key={item}>
                                    <div className='w-full'>
                                        <p className='text-f7 font-normal text-[#031624] w-full more-lines break-all' title={item}>{item}</p>
                                    </div>
                                </div>))}
                        </div>
                    </div>
                </div>
            </div>
            <div class=" flex -mx-2.5 mt-5">
                <div class="w-1/2 px-2.5">
                    <div class="w-full flex justify-end">
                        <button 
                            onClick={() => {handleSidePopupClick();getPayrollUsers()}}
                            type="button" 
                            id='Cancel'
                            class="cancl-btn" data-te-modal-dismiss="" aria-label="Close">Cancel</button>
                    </div>
                </div>
                {/* <div class="w-1/2">
                    <div class="w-full">
                        <button 
                            type="button" 
                            id="upload" 
                            onClick={() => setFailureData({})}
                            // disabled={changedOngoingFY?.name === "" || changedOngoingFY.name === undefined}
                            class="actn-btn onboardInstitution" 
                            tabindex="0"
                        >Go Back</button>
                    </div>
                </div> */}
            </div>
            
        </div>
    )
}
